import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
import api from 'api';
import credentialsService from 'services/credentialsService';
import classNames from 'classnames';
import FourDotLoader from 'components/FourDotLoader';
import PopNotificationsContext from 'providers/PopNotifications/PopNotifications.context';
import AuthPageWrapper from 'components/AuthPageWrapper';
import { Link } from 'react-router-dom';

import './VerifyEmail.styles.scss';

type VerifyEmailProps = {
  className?: string;
};

const VerifyEmail: React.FC<VerifyEmailProps> = (props) => {
  const { className } = props;
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccessfull, setIsSuccessfull] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { popError } = useContext(PopNotificationsContext);

  const classes = classNames('verify-email', className);

  const verifyEmail = useCallback(async () => {
    if (!token) {
      navigate('/');
      popError(t('something-went-wrong'));
      return;
    }
    setIsLoading(true);
    try {
      await api.user.verifyEmail(token);

      setIsSuccessfull(true);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
      credentialsService.removeAuthBody();
    }
  }, [navigate, popError, t, token]);

  useEffect(() => {
    verifyEmail();
  }, [verifyEmail]);

  if (isLoading) return <FourDotLoader />;

  return (
    <AuthPageWrapper>
      <div className={classes}>
        <p className="fm-card-title">
          {isSuccessfull ? t('email-verified') : t('verifying-failed')}
        </p>
        <p>{isSuccessfull ? t('you-can-redirect') : t('verify-expired')}</p>

        <Link to="/login">{t('redirect-to-login')}</Link>
      </div>
    </AuthPageWrapper>
  );
};

export default VerifyEmail;
